import { render, staticRenderFns } from "./GovernanceWarningBanner.vue?vue&type=template&id=1f125ad6&scoped=true"
import script from "./GovernanceWarningBanner.vue?vue&type=script&lang=js"
export * from "./GovernanceWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./GovernanceWarningBanner.vue?vue&type=style&index=0&id=1f125ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f125ad6",
  null
  
)

export default component.exports